export enum ActivityTypeList {
  CALL = '44674d08-442c-475d-a45c-05d92eadaa70',
  EVENT = 'b74fbc51-1739-4ae3-b172-6c5408d60d0c',
  VISIT = '7ca0e12d-a840-493d-9354-140b2f0300b8',
  EMAIL = '2c003d63-741d-40ee-a6d7-2da3091f4fb9',
  VIDEOCONF = 'b44353fe-2e5f-49c5-86b5-29ace832061e',
}
